import { render, staticRenderFns } from "./ManejoTransferencias.vue?vue&type=template&id=d07a2f2c"
import script from "./ManejoTransferencias.vue?vue&type=script&lang=js"
export * from "./ManejoTransferencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports